import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

export default function Navbar() {
  const { lang, toggleLang, t } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className="site-header">
      <div className="container">
        <div className="navbar-inner">
          {/* Brand Logo: Only <W> Dot-Matrix */}
          <a href="#top" className="brand-neo" onClick={closeMobile} aria-label="Ana Sayfa">
            <Logo />
          </a>

          {/* Nav Links */}
          <nav className="nav-links-neo" aria-label="Ana Navigasyon">
            {t.navLinks.map((link) => (
              <a key={link.id} href={`#${link.id}`} className="nav-link-neo">
                {link.label}
              </a>
            ))}
          </nav>

          {/* Right Cluster */}
          <div className="nav-right-neo">
            {/* Language Switcher */}
            <button
              type="button"
              className="lang-toggle-neo"
              onClick={toggleLang}
              aria-label="Dili Değiştir / Switch Language"
              title="Dili Değiştir / Switch Language"
            >
              <span className={lang === 'tr' ? 'lang-active-neo' : ''}>TR</span>
              <span style={{ color: '#525866' }}>|</span>
              <span className={lang === 'en' ? 'lang-active-neo' : ''}>EN</span>
            </button>

            <a
              href={t.personalInfo.github}
              target="_blank"
              rel="noreferrer"
              className="btn-neo btn-neo-dark nav-desktop-btn"
              style={{ padding: '0.4rem 0.85rem', fontSize: '0.82rem' }}
              aria-label="GitHub Profili"
            >
              <i className="fa-brands fa-github"></i>
              <span>GitHub</span>
            </a>

            <a
              href="#iletisim"
              className="btn-neo btn-neo-chrome nav-desktop-btn"
              style={{ padding: '0.4rem 1.05rem', fontSize: '0.84rem' }}
            >
              <span>{t.ui.letsTalk}</span>
              <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.75rem' }}></i>
            </a>

            <button
              type="button"
              className="mobile-menu-btn-neo"
              onClick={() => setMobileOpen((prev) => !prev)}
              aria-label={mobileOpen ? 'Menüyü Kapat' : 'Menüyü Aç'}
            >
              <i className={`fa-solid ${mobileOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu Drawer */}
        <div className={`mobile-drawer-neo ${mobileOpen ? 'open' : ''}`}>
          {t.navLinks.map((link) => (
            <a key={link.id} href={`#${link.id}`} className="mobile-link-neo" onClick={closeMobile}>
              {link.label}
            </a>
          ))}
          <a href="#iletisim" className="btn-neo btn-neo-chrome" onClick={closeMobile} style={{ marginTop: '0.5rem', width: '100%' }}>
            {t.ui.letsTalk}
          </a>
        </div>
      </div>
    </header>
  );
}
